import React from 'react';
import * as Icons from 'lucide-react';

const RCSComingSoon = () => {
  return (
    <div className="min-h-[70vh] flex items-center justify-center">
      <div className="text-center max-w-lg">
        <div className="w-24 h-24 rounded-3xl flex items-center justify-center mx-auto mb-6" style={{
          background: 'linear-gradient(135deg, rgba(66, 133, 244, 0.1), rgba(52, 168, 83, 0.1))',
        }}>
          <Icons.Smartphone className="w-12 h-12" style={{ color: '#4285F4' }} />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-3">Google RCS Messaging</h1>
        <p className="text-gray-500 mb-6 leading-relaxed">
          Rich Communication Services (RCS) brings rich media, interactive buttons, carousels, and verified sender identity to business messaging. Coming soon to your platform.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
          {[
            { icon: 'Image', label: 'Rich Media', desc: 'Images, videos, carousels' },
            { icon: 'MousePointerClick', label: 'Interactive', desc: 'Buttons, quick replies' },
            { icon: 'ShieldCheck', label: 'Verified', desc: 'Verified sender identity' },
          ].map((feature) => {
            const Icon = Icons[feature.icon];
            return (
              <div key={feature.label} className="p-4 rounded-xl border border-gray-100 bg-white">
                {Icon && <Icon className="w-6 h-6 mx-auto mb-2" style={{ color: '#4285F4' }} />}
                <p className="text-sm font-semibold text-gray-900">{feature.label}</p>
                <p className="text-xs text-gray-400 mt-0.5">{feature.desc}</p>
              </div>
            );
          })}
        </div>
        <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-medium" style={{
          background: 'linear-gradient(135deg, rgba(66, 133, 244, 0.08), rgba(52, 168, 83, 0.08))',
          color: '#4285F4',
          border: '1px solid rgba(66, 133, 244, 0.15)',
        }}>
          <Icons.Clock className="w-4 h-4" />
          Coming Soon - Under Development
        </div>
      </div>
    </div>
  );
};

export default RCSComingSoon;
